export const tr = (entry, locale) => entry?.[locale] ?? entry?.en ?? ''

export const trVars = (entry, locale, vars = {}) => {
  let str = tr(entry, locale)
  Object.entries(vars).forEach(([key, value]) => {
    str = str.replaceAll(`{${key}}`, value ?? '')
  })
  return str
}
